import { zSchema } from "@zeal/common";
import {
  publicIDUploadLinkSchema,
  TIDUploadLinkResponse,
} from "../shared/idUploadTypes";

/**
 * Request schema for generating contractor document upload links
 * Extends the shared public schema with contractor-specific fields
 */
export const postGenerateContractorIDUploadLinkSchema =
  publicIDUploadLinkSchema.extend({
    contractorID: zSchema.string().min(1, "Contractor ID is required"),
  });

export type TPostGenerateContractorIDUploadLinkRequest = zSchema.infer<
  typeof postGenerateContractorIDUploadLinkSchema
>;

export type TPostGenerateContractorIDUploadLinkResponse = TIDUploadLinkResponse;
